import axios from 'axios'

import { CouponShowCaseModel } from '@/types/Coupon'
import { CustomerMVPModel } from '@/types/Customer'

export async function GetCouponShowCase (type: number): Promise<CouponShowCaseModel[]> {
  const response = await axios.post('/ajax/coupon.aspx/GetCouponShowCase', { type: type })
  const data = response.data
  const list = data.d.Data as []
  const infos = list.map((p: any) => {
    return { ...new CouponShowCaseModel(), ...p }
  })
  return infos || []
}

export async function GetCustomerMVPInfo ():Promise<CustomerMVPModel> {
  const response = await axios.post('/ajax/customer.aspx/GetCustomerMVPInfo', {})
  const data = response.data
  const info = data.d.Data as CustomerMVPModel
  return info || {}
}
